import {mapGetters} from 'vuex'
import _ from 'lodash'

import appTextfieldLazy from '@/components/app-textfield-lazy/index.vue'
import Vue from "vue";
import {getFiltersParams, setFiltersFromParams} from '@/utils/filtersCommon'

export default {
  name: 'filters',
  //---components
  components: {
    appTextfieldLazy
  },
  /**
   * @emit
   * change
   */
  //---data
  data () {
    return {
      filtersCollection: null,
      generalFiltersNames: ['search','price', 'county'],
      filterErrorText: [],
      flags: {
        isShowAdditionalFilters: false
      },
      validationRules: {
        decimal:  [
          value => (value || '').length <= 12 || '',
          value => {
            const pattern = /^(([1-9][0-9]*)|(0))([.][0-9]{1,2})?$/;
            return ((value && pattern.test(value)) || !value) || ''
          }
        ],
        year:  [
          value => (value || '').length <= 4 || '',
          value => {
            const pattern = /^(19[0-9]{2}|20[0-2][0-9]|2030)$/;
            return ((value && pattern.test(value)) || !value) || ''
          }
        ]
      }
    }
  },
  //---hooks
  created() {},
  watch: {
    '$route.query': {
      immediate: true,
      handler: function (e) {
        let filters = _.cloneDeep(this.filtersScheme);

        if (Object.keys(this.$route.query).length) {
          filters = setFiltersFromParams(filters, this.$route.query)
          this.flags.isShowAdditionalFilters = this._setExpanderToggler(filters, this.$route.query);
        }
        this.filtersCollection = filters;
      }
    },
  },
  computed: {
    ...mapGetters({
      filtersScheme: 'FILTERS/filtersScheme',
    }),
    getBtnTogglerTitle: function() {
      return this.flags.isShowAdditionalFilters ? 'Hide Filters' : 'Show Filters';
    }
  },
  //---methods
  methods: {
    toggleExpandPanel() {
      this.flags.isShowAdditionalFilters = !this.flags.isShowAdditionalFilters;

      if (!this.flags.isShowAdditionalFilters) {
        let self = this;
        setTimeout(()=>{
          self._resetAdditionalFilters();
        },400);
      }
    },

    _setExpanderToggler(filters, query) {
      let queryKeysString = Object.keys(query).join(',');
      let filterAdditionalKeys = filters.map(filter => filter.name).filter(name => this.generalFiltersNames.indexOf(name) === -1)

      return filterAdditionalKeys.some(key => queryKeysString.indexOf(key) > -1);
    },

    _resetAdditionalFilters() {
      //---NOTE: type: value = [null] | select = [null] | range = [null,null]  | multiselect = []
      let isChangeAdditionalFilters = false;

      this.filtersCollection.forEach( (filter, index) => {
        if (this.generalFiltersNames.indexOf(filter.name) === -1) {
          if (filter.type === 'range') {
            if( filter.values[0] !== null && filter.values[0] !== '') {
              filter.values[0] = null;
              isChangeAdditionalFilters = true;
            }
            if( filter.values[1] !== null && filter.values[0] !== '') {
              filter.values[1] = null;
              isChangeAdditionalFilters = true;
            }

            filter._dec.isErrorMin = false;
            filter._dec.isErrorMax = false;
          } else if (filter.type === 'select') {
            if( filter.values[0] !== null && filter.values[0] !== '') {
              filter.values[0] = null;
              isChangeAdditionalFilters = true;
            }

          } else {
            if( filter.values.length > 0) {
              filter.values = [];
              isChangeAdditionalFilters = true;
            }
          }
          Vue.set(this.filtersCollection, index, filter);
        }
      });

      if (isChangeAdditionalFilters) {
        this.getFiltersChange()
      } else {
        this.$refs.filtersForm.validate();
      }
    },

    getFiltersChange() {
      if (this._isValidFilters()) {
        this.$emit('change',getFiltersParams(this.filtersCollection));
      }
    },

    _isValidFilters() {
      let isValid = true;

      if (this.$refs.filtersForm.validate()) {
        this.filterErrorText = [];
        this.filtersCollection.forEach( (filter,index) => {
          if (filter.type === 'range') {
            if (filter.values[0] !== undefined && filter.values[0] !== null && filter.values[0] !== '' && filter.values[1] !== undefined && filter.values[1] !== null && filter.values[1] !== '') {
              if (parseFloat(filter.values[0]) <= parseFloat(filter.values[1]) ) {
                filter._dec.isErrorMin = false;
                filter._dec.isErrorMax = false;
              } else {
                filter._dec.isErrorMin = true;
                filter._dec.isErrorMax = true;
                isValid = false;
              }
            } else {
              filter._dec.isErrorMin = false;
              filter._dec.isErrorMax = false;
            }

            Vue.set(this.filtersCollection, index, filter);
          }
        });
      } else {
        isValid = false;
      }
      return isValid
    }
  }
}
